import { Ufo } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.ExternalContent];

const config: ContentConfigProps = {
  routes: {
    create: routes.ExternalContentCreator,
    edit: routes.ExternalContentEditor,
    duplicate: routes.ExternalContentDuplicate,
    details: routes.ExternalContentDetails,
    manageDetails: routes.AdminExternalContentDetails,
  },
  label: { title, createDescription },
  icons: {
    Type: Ufo,
    Create: Ufo,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
